export default "__VITE_ASSET__1ebeba4d__"